import { NgModule} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { BsDatepickerModule, BsDropdownModule, CollapseModule, ModalModule } from "ngx-bootstrap";
import { InterceptorService } from "../../../service/components/authentication/interceptor.service";
import { UserManageService } from "../../../service/api/jubili/user-manage.service";
import { UserTableComponent } from "./table/table.component";
import { UserManagerDetailComponent } from "./user-manager-detail/user-manager-detail.component";
import { PipeModule } from "../../../pipe/pipe.module";
import { LoadingModule } from "ngx-loading";
// ------------------------------------------End Service----------------------------------------------------------------------//

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        SharedModule,
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        ModalModule.forRoot(),
        PipeModule,
        BsDatepickerModule.forRoot(),
        LoadingModule
    ],
    declarations: [
        UserTableComponent,
        UserManagerDetailComponent
    ],
    exports: [
        UserTableComponent,
        UserManagerDetailComponent,
        SharedModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        UserManageService
    ]
})

export class UserManagerModule { }
